import application from 'application/application';

application
	//Formata o numero para o padrão CNJ -> 0000000-00.0000.0.00.0000
	.filter('formatToCNJ', function() {
		return function(input) {
			if (input.length == 20 && !isNaN(input)) {
				return input.replace(/(\d{7})(\d{2})(\d{4})(\d{1})(\d{2})(\d{4})/,'$1-$2.$3.$4.$5.$6');
			}
			else {
				return input;
			}
		};
	});

